// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24Pop","col":"styles_col__2J2D1"};